import UserStatsList from './UserStatsList';

export default {
    list: UserStatsList,
};
